type LoadingComponentProps = {
  /** Optional label shown next to the spinner */
  label?: string
  /** Extra class on the wrapper (e.g. min-height for empty tables) */
  className?: string
}

/**
 * In-table / in-content loader only. Do not use for a top-of-page / header progress bar.
 */
const LoadingComponent = ({ label = 'Loading...', className = '' }: LoadingComponentProps) => {
  return (
    <div
      className={`ss-table-loading d-flex justify-content-center align-items-center py-8 ${className}`.trim()}
      role='status'
      aria-live='polite'
      aria-busy='true'
    >
      <div className='ss-table-loading__inner d-flex flex-column align-items-center gap-3'>
        <span className='spinner-border text-primary' aria-hidden='true' />
        <span className='ss-table-loading__label text-gray-600 fw-semibold'>{label}</span>
      </div>
    </div>
  )
}

export { LoadingComponent }
